var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import React from 'react';
import { Helmet } from "react-helmet";
import PropTypes from 'prop-types';
import { withRouter, Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import timezone from 'moment-timezone';
import moment from 'moment';
import { getFullLine as getFullLineAction, clearLine as clearLineAction, fetchPreMatchMenu as fetchPreMatchMenuAction } from '../../../actions/creators/lines';
import { clearLiveMatch as clearLiveMatchAction } from '../../../actions/creators/live';
import { setActiveTab as setActiveTabAction } from '../../../actions/creators/sidebar';
import { isSlotTypeFavorite, _getFavoriteSlotTypesFromLocalStorage } from './slots/SlotLocalStorageManager';
import slotTypeProvider from '../providers/SlotTypeProvider';
import slotIdProvider from '../providers/SlotIdProvider';
import slotFamilyProvider from '../providers/SlotFamilyProvider';
import slotFactory from '../factories/SlotFactory';
import PreMatchHeader from './preMatchHeader';
import LiveHeader from './liveHeader';
import SlotArrangementPolicy from '../slot-arrangement-policies';
import ToggledSections from './toggled-outcomes';
import slotComponentFactory from './slotComponentFactory';
import FinishImage from '../../../assets/img/finish.svg';
import { defineMessages, injectIntl } from 'react-intl';
import LiveMatchWidgets from './LiveMatchWidgets';
var messages = defineMessages({
    sports_no_markets: {
        id: 'sports.no_markets',
        defaultMessage: 'Нет доступных исходов'
    },
    sports_no_events_title: {
        id: 'sports.no_events_title',
        defaultMessage: 'Событие недоступно'
    },
    sports_no_events: {
        id: 'sports.no_events',
        defaultMessage: 'Событие, которое вы просматривали, завершено или больше не доступно.'
    },
    sports_no_events_btn: {
        id: 'sports.no_events_btn',
        defaultMessage: 'Перейти в Live'
    }
});
function slotPositionComparator(a, b) {
    if (a.position > b.position) {
        return 1;
    }
    if (a.position < b.position) {
        return -1;
    }
    return 0;
}
var EventLive = /** @class */ (function (_super) {
    __extends(EventLive, _super);
    function EventLive() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.componentWillUnmount = function () {
            _this.props.clearLiveMatchAction();
        };
        return _this;
    }
    EventLive.prototype.componentWillMount = function () {
        root.scrollTo(0, 0);
        this.props.clearLineAction();
    };
    EventLive.prototype.componentDidMount = function () {
        var tab = this.props.section === 'liveMatch' ? 'live' : 'sport';
        this.props.setActiveTabAction(tab);
    };
    EventLive.prototype.getSlots = function () {
        var match = this.props.match;
        var outcomes = this.props.outcomes;
        var realSportId = match.get('realSportId');
        var sportId = match.get('sportId');
        var slotsMap = {};
        var slots = [];
        outcomes.forEach(function (o) {
            var slotType = slotTypeProvider(realSportId, o.get('type'));
            var slotFamily = slotFamilyProvider(realSportId, slotType);
            var slotFavorite = isSlotTypeFavorite(slotType, realSportId);
            var slotId = slotIdProvider(slotType, slotFamily, o);
            var slot = slotsMap[slotId];
            if (slot === undefined) {
                slot = slotFactory(slotId, slotType, slotFamily, o);
                slotsMap[slotId] = slot;
                slot.position = SlotArrangementPolicy.getPosition(realSportId, 1, slot);
                if (ToggledSections[realSportId] !== undefined) {
                    slot.toggled = !!ToggledSections[realSportId].find(function (s) { return s === slot.type; });
                }
                slot.sportId = sportId;
                slot.favorite = slotFavorite;
                slots.push(slot);
            }
            slot.outcomes.push(o.get('id'));
        });
        slots.sort(slotPositionComparator);
        return slots;
    };
    EventLive.prototype.renderSlots = function (slots) {
        var match = this.props.match;
        var outcomes = this.props.outcomes;
        var languageId = this.props.languageId;
        var rates = this.props.rates;
        var gridLocalization = this.props.gridLocalization;
        var section = this.props.section;
        var sportId = match.get('realSportId');
        var matchObj = {
            homeTeam: match.get('firstTeam'),
            awayTeam: match.get('secondTeam')
        };
        var slotElements = [];
        var i = 0;
        slots.map(function (slot) {
            var filteredOutcomes = outcomes
                .filter(function (outcome) { return slot.outcomes.includes(outcome.get('id')); })
                .map(function (o) {
                return o.set('name', gridLocalization.getOutcomeName(sportId, o.toJS(), matchObj));
            });
            var filteredRates = rates
                .filter(function (r) { return slot.outcomes.includes(r.get('outcomeId')); })
                .map(function (r) {
                var outcome = filteredOutcomes.get(r.get('outcomeId'));
                return r.set('shortName', gridLocalization.getRateName(sportId, outcome.toJS(), r.get('type'), matchObj));
            });
            var key = slot.id;
            var SlotRenderer = slotComponentFactory(slot.family);
            var props = {
                slot: slot,
                match: match,
                filteredRates: filteredRates,
                outcomes: filteredOutcomes,
                gridLocalization: gridLocalization,
                section: section,
                languageId: languageId,
                expanded: i === 0
            };
            slotElements.push(_createElement(SlotRenderer, __assign({}, props, { key: key })));
            i++;
        });
        return slotElements;
    };
    EventLive.prototype.getFavoriteSlots = function (slots, sportId) {
        var resultFavoriteSlots = [];
        var favoriteSlots = slots.filter(function (slot) { return slot.favorite === true; });
        var favoriteSlotTypes = _getFavoriteSlotTypesFromLocalStorage(sportId);
        favoriteSlotTypes.forEach(function (slotType) {
            resultFavoriteSlots = resultFavoriteSlots.concat(favoriteSlots.filter(function (slot) { return slot.type === slotType; }));
        });
        return resultFavoriteSlots;
    };
    EventLive.prototype.getTypicalSlots = function (slots) {
        return slots.filter(function (slot) { return slot.favorite === false; });
    };
    EventLive.prototype.render = function () {
        var _a = this.props, fetching = _a.fetching, match = _a.match, sportName = _a.sportName, sportId = _a.sportId, leagueName = _a.leagueName, activeTab = _a.activeTab, gridLocalization = _a.gridLocalization, section = _a.section, languageId = _a.languageId, repositoryState = _a.repositoryState, isMatchNotFound = _a.isMatchNotFound;
        if (isMatchNotFound) {
            return (_jsxs("div", __assign({ className: 'content', id: 'content' }, { children: [_jsx(Helmet, { children: _jsx("title", { children: this.props.intl.formatMessage(messages.sports_no_events_title) }) }), _jsxs("div", __assign({ className: 'no_events' }, { children: [_jsx("img", { src: FinishImage, alt: '' }), _jsx("div", __assign({ className: 'no_events__title' }, { children: this.props.intl.formatMessage(messages.sports_no_events_title) })), _jsx("div", __assign({ className: 'no_events__info' }, { children: this.props.intl.formatMessage(messages.sports_no_events) })), _jsx(Link, __assign({ className: 'no_events__btn', to: '/' }, { children: this.props.intl.formatMessage(messages.sports_no_events_btn) }))] }))] })));
        }
        if (fetching || repositoryState === 1) {
            return (_jsx("div", __assign({ className: 'content' }, { children: _jsx("div", { className: 'please_wait' }) })));
        }
        if (match === undefined) {
            return null;
        }
        var name = match.get('name');
        var tv = match.get('channel');
        var radarId = match.get('radarId');
        var startDate = match.get('startDate');
        var tzGuess = timezone.tz.guess();
        var date = moment.tz(startDate, tzGuess).clone();
        var slots = this.getSlots();
        var renderHeader;
        var props = {
            sportId: sportId,
            leagueName: leagueName,
            name: name,
            date: date,
            languageId: languageId,
            tv: tv
        };
        var liveProps = __assign(__assign({}, props), { languageId: languageId, leagueName: leagueName, match: match, gridLocalization: gridLocalization, section: section, goBack: this.props.history.goBack, radarId: radarId });
        if (activeTab === 'live') {
            renderHeader = _jsx(LiveHeader, __assign({}, liveProps));
        }
        else {
            var preMatchProps = __assign(__assign({}, props), { match: match, sportName: sportName, goBack: this.props.history.goBack });
            renderHeader = _jsx(PreMatchHeader, __assign({}, preMatchProps));
        }
        var realSportId = match.get('realSportId');
        var favoriteSlots = this.getFavoriteSlots(slots, realSportId);
        var typicalSlots = this.getTypicalSlots(slots);
        var isRadarWidgetAvailable = !(RegExp(/(3x3)|(3X3)|(3х3)|(3Х3)/).test(leagueName)) && radarId;
        return (_jsx("div", __assign({ className: 'content', id: 'content' }, { children: _jsxs("div", __assign({ className: 'block blc_event' }, { children: [renderHeader, isRadarWidgetAvailable && _jsx(LiveMatchWidgets, __assign({}, liveProps)), match.get('isBlocked') && _jsx("div", __assign({ className: 'no_outcomes' }, { children: this.props.intl.formatMessage(messages.sports_no_markets) })), !match.get('isBlocked') && this.renderSlots(favoriteSlots), !match.get('isBlocked') && this.renderSlots(typicalSlots)] })) })));
    };
    return EventLive;
}(React.Component));
EventLive.propTypes = {
    fetchPreMatchMenuAction: PropTypes.func.isRequired,
    gridLocalization: PropTypes.object.isRequired,
    fetching: PropTypes.bool.isRequired,
    eventId: PropTypes.number.isRequired,
    sportName: PropTypes.string,
    sportId: PropTypes.any,
    leagueName: PropTypes.string,
    match: PropTypes.object,
    outcomes: PropTypes.object,
    rates: PropTypes.object,
    section: PropTypes.string.isRequired,
    activeTab: PropTypes.string.isRequired
};
function mapStateToProps(state, props) {
    var section = props.section;
    var eventId = props.eventId || +props.match.params.eventId;
    var match = state.application.getIn([section, 'matches', eventId]);
    var outcomes = state.application.getIn([section, 'outcomes'])
        .filter(function (outcome) { return outcome.get('matchId') === eventId; });
    var rates = state.application.getIn([section, 'rates'])
        .filter(function (rate) { return rate.get('matchId') === eventId; });
    var sportName = '';
    var sportId = '';
    var leagueName = '';
    if (match) {
        sportId = state.application.getIn([section, 'sports', match.get('sportId')]).get('id');
        sportName = state.application.getIn([section, 'sports', match.get('sportId')]).get('name');
        leagueName = state.application.getIn([section, 'leagues', match.get('leagueId')]).get('name');
    }
    return {
        routing: state.routing,
        eventId: eventId,
        languageId: state.application.get('languageId'),
        fetching: state.application.getIn([section, 'fetching']),
        repositoryState: state.application.getIn([section, 'state']),
        isMatchNotFound: state.application.getIn([section, 'isMatchNotFound']),
        sportId: sportId,
        sportName: sportName,
        leagueName: leagueName,
        match: match,
        outcomes: outcomes,
        rates: rates,
        activeTab: state.application.get('activeTab')
    };
}
var mapDispatchToProps = function (dispatch) { return bindActionCreators({
    getFullLineAction: getFullLineAction,
    setActiveTabAction: setActiveTabAction,
    fetchPreMatchMenuAction: fetchPreMatchMenuAction,
    clearLineAction: clearLineAction,
    clearLiveMatchAction: clearLiveMatchAction,
}, dispatch); };
EventLive = connect(mapStateToProps, mapDispatchToProps)(EventLive);
export default withRouter(injectIntl(EventLive));



// WEBPACK FOOTER //
// ./src/components/grid/event/EventLive.jsx